var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPizzaAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31772 16.3686L2.14103 18.3138C1.85799 18.7817 2.012 19.3843 2.5042 19.6457C5.33343 21.1481 8.56639 22 12 22C15.4335 22 18.6666 21.1481 21.4958 19.6457C21.988 19.3843 22.142 18.7817 21.859 18.3138L20.6823 16.3686C15.4062 19.6643 8.59378 19.6643 3.31772 16.3686Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10199 15.0721C8.89313 18.098 15.1069 18.098 19.898 15.0721L12.8956 3.49596C12.4956 2.83468 11.5043 2.83468 11.1043 3.49596L4.10199 15.0721Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizzaAlt);
export default __webpack_public_path__ + "static/media/pizza-alt.d79eb285826a8dd8870d48005868f22f.svg";
export { ForwardRef as ReactComponent };